import React from 'react';
import {observer, useAsObservableSource} from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { CampaignName,
    CampaignNameValue,
    TrashIconWrapper,
    ActionsWrapper,
    ActiveLabel
} from './SpecialSportsListItem.styles';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { SpecialSportsModelType } from 'src/api/config/special_sports/getSpecialSports';
import { SpecialSportsState } from 'src/AppState/CmsState/SpecialSportsState/SpecialSportsState';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ListItem } from 'src/domains/layouts/shared/cms/list/List.style';

interface EventDetailsPropsType {
    specialSportsItem: SpecialSportsModelType
}

class State {
    constructor(
        private readonly specialSportsState: SpecialSportsState,
        private readonly specialSports: SpecialSportsModelType,
    ) {
    }

    onChangePageToEdit = (): void => {
        this.specialSportsState.setEditMode(true);
        this.specialSportsState.setEditEventDetails(this.specialSports);

    };

    onRemove = (): void => {
        this.specialSportsState.handleRemoveApiCall(this.specialSports.id);
    }

    changeActiveFlag = (): void => {
        this.specialSportsState.setActiveFlag(this.specialSports);
    }
}

export const SpecialSportsListItem = observer(({ specialSportsItem}: EventDetailsPropsType) => {
    const { cmsState } = useAppStateContext();
    const specialSportsObservable = useAsObservableSource(specialSportsItem);
    const [ state ] = React.useState(() => new State(cmsState.specialSportsState, specialSportsObservable));

    const { changeActiveFlag, onChangePageToEdit, onRemove } = state;

    return (
        <ListItem homepage={false} boxHeight='82px' data-test='special-sport-item' direction='row'>
            <div>
                <div><CampaignName data-test='special-sport-slug'>Slug: {specialSportsItem.slug}</CampaignName></div>
                <div><CampaignName data-test='special-sport-name'>Label: </CampaignName><CampaignNameValue data-test='special-sport-name-value'>{specialSportsItem.label}</CampaignNameValue></div>
            </div>

            <ActionsWrapper>
                <Checkbox labelSide='right' onChange={changeActiveFlag} isChecked={specialSportsItem.is_active} isDisabled={false}>
                    <ActiveLabel>Active Sport</ActiveLabel>
                </Checkbox>
                <Button version='secondary' size='small' onClick={onChangePageToEdit}>Edit</Button>
                <TrashIconWrapper onClick={onRemove}/>
            </ActionsWrapper>
        </ListItem>
    );
});
